<template>
  <div>
    <div class="d-flex w-100 justify-space-center">
      <img :src="arriboOnBoarding" alt="Arribo Hero" class="onboard-img">
    </div>
    <div class="verify-account-wrapper__verify ion-justify-content-center">
      <ion-row>
        <ion-col size="12" class="pb-lg">
          <p class="font-lg py-xs">{{ t('onBoardingRelocated.arriboIs') }}</p>
          <p class="font-sm py-xs text-align-left">
            <b>{{ organizationData.organization.legalName }}</b> {{ t('onBoardingRelocated.prepared') }}
          </p>
          <p class="font-sm text-align-left">
            {{ t('onBoardingRelocated.however') }}
          </p>
        </ion-col>
        <ion-col size="12">
          <ion-button
            fill="solid"
            expand="block"
            size="large"
            color="accent"
            class="text-lg text-weight-bold"
            @click="goTo('profile.my')"
          >
          {{ t('onBoardingRelocated.review') }}
          </ion-button>
        </ion-col>
        <ion-col size="12">
          <ion-button
            data-test="submit"
            fill="clear"
            class="text-lg text-underline"
            color="white"
            expand="block"
            size="small"
            @click="goTo('welcome')"
          >
          {{ t('onBoardingRelocated.remind') }}
          </ion-button>
        </ion-col>
      </ion-row>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { IonButton, IonCol, IonRow } from '@ionic/vue';
  import arriboOnBoarding from '@/assets/images/arribo-onboarding.svg';
  import { useI18n } from 'vue-i18n';
  import { useAuth } from '@/composables/useAuth';

  withDefaults(
    defineProps<{
      organizationData: any;
    }>(),
    {},
  );

  const { t } = useI18n();
  const { goTo } = useAuth();
</script>
<style scoped lang="scss">
  .onboard-img {
    max-width: 300px !important;
    width: 100% !important
  }
</style>
